'use strict';

var _reflux = require('reflux');

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _reflux2.default.createActions(['getAllData', 'addItemToCart', 'updateItemInCart', 'removeItemFromCart', 'addPaymentMethod', 'detachPaymentMethod', 'deleteDeliveryAddress', 'addOrderInstructions', 'clearCartStore', 'informLoginChange', 'loadFbLoginApi', 'applyCoupon', 'removeCoupon', 'addTip', 'removeTip', 'refreshTip', 'resetScheduledDate', 'showOrderScheduler', 'resetPaymentMethod', 'addIsUtensilsAndNapkinsEnabled', 'updateRoundOffStatus', 'getRoundOffStatus', 'getTotalFixedChargeFee', 'onMainDataCustom', 'updateDefaultOptionalCharge', 'updateDefaultOptionalChargeCustom', 'getCalculateFeeOfCharge', 'updateCustomFieldValue', 'updateDefaultOptionalChargeValue', 'resetCustomChargeDataOfCart', 'scheduleDateTime', 'clearScheduleScreenStore']);


//////////////////
// WEBPACK FOOTER
// ./src/Actions.jsx
// module id = 182
// module chunks = 0